import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "bg-white shadow-xl absolute p-1 w-52 z-10 action-menu custom-border at-action-menu"
};
const _hoisted_2 = {
  class: "list-none m-0"
};
const _hoisted_3 = ["onClick"];
export default {
  __name: 'RateGroupActionMenu',
  props: {
    rateGroup: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const menuItems = [{
      action: 'edit',
      label: 'Edit'
    }, {
      action: 'delete',
      label: 'Delete'
    }, {
      action: 'duplicate',
      label: 'Duplicate'
    }, {
      action: 'setDefault',
      label: 'Set as Default'
    }];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, item => {
        return _createElementVNode("li", {
          class: "border-bottom",
          key: item.action
        }, [_createElementVNode("button", {
          class: "menu-button",
          onClick: $event => _ctx.$emit('menuButton', item.action, __props.rateGroup)
        }, _toDisplayString(item.label), 9, _hoisted_3)]);
      }), 64))])]);
    };
  }
};